import React, { useState } from "react";
import RateCard from "./RateCard";
import Concierge from "./Concierge";

export default function App() {
  const [talking, setTalking] = useState(false);
  return (
    <>
      <RateCard onTalk={() => setTalking(true)} />
      {talking && <Concierge onClose={() => setTalking(false)} />}
    </>
  );
}
